export default {
  list: [
    {
      id: 0,
      name: 'Attach',
      patentPending: true,
      description: 'MikMak Attach turns a video view into a purchase by improving the swipe up commerce experience within Instagram and Snapchat',
      device: {
        color: 'white-device',
        rotation: '1deg',
        image: '//mikmak.s3.amazonaws.com/uploads/49ac9dc1-1ac5-417b-8d41-4225d1b5bd79/with-cart.gif'
        // image: '//mikmak.s3.amazonaws.com/uploads/49ac9dc1-1ac5-417b-8d41-4225d1b5bd79/without-cart.gif'
      },
      bullets: [
        'Extend the shelf life of your video content',
        'Add-to-cart made easy',
        'See direct sales attribution from social',
        'Opportunity to re-market to customers',
        'Integrates with <i class="fa fa-instagram" aria-hidden="true"></i> and <i class="fa fa-snapchat" aria-hidden="true"></i>'
      ],
      orientation: 'left',
      boxStyles: {
        backgroundColor: 'rgba(230, 230, 230, 0.59)'
      },
      cta: 'Request a Demo'
    },
    {
      id: 1,
      name: 'Studios',
      description: 'MikMak creates short form, shoppable video',
      device: {
        color: 'white-device',
        rotation: '-2deg',
        image: '//mikmak.s3.amazonaws.com/uploads/8f15e585-73df-4f10-ae03-36ffb1c3ec67/ezgif.com-video-to-gif-iloveimg-compressed.gif'
      },
      bullets: [
        'Our in-house team produces fun and catchy videos designed to drive engagement and purchase'
      ],
      orientation: 'right',
      boxStyles: {
        backgroundColor: 'rgb(241, 241, 241)'
      },
      cta: 'Request a Quote'
    },
    {
      id: 2,
      name: 'Measure',
      description: 'MikMak Measure is an analytics dashboard that provides data and insights about the performance of a brand\'s shoppable video',
      bullets: [
        'Real time funnel visualization',
        'One click data filters',
        'Customer journey mapping',
        'Shoppable video analysis by the second'
      ],
      orientation: 'left',
      boxStyles: {
        backgroundColor: 'rgba(230, 230, 230, 0.59)'
      },
      cta: 'Request a Demo'
    },
    {
      id: 3,
      name: 'Live',
      description: 'Instantly turn Facebook Live into an engaging shopping experience <i class="fa fa-facebook-official" aria-hidden="true"></i>',
      bullets: [],
      orientation: 'left',
      boxStyles: {
        backgroundColor: 'rgb(241, 241, 241)'
      },
      cta: 'Apply for the beta'
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/imports/Products.js